module.exports = __webpack_public_path__ + "media/images/ui__textArrowDown-b8b1814731d6a2c5e80eb5443d4fa47d.png";